<template>
    <el-form status-icon :model="aracModelForm" :rules="rulesAracModel" ref="aracModelForm" @submit.native.prevent="enter"
             class="demo-ruleForm">
        <div>
            <el-row>
                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item label='Marka' prop="marka" class="margin-top-20">
                        <el-select
                                v-on:change="markaChange"
                                v-model="aracModelForm.marka"
                                style="width: 100%">
                            <el-option v-for="item in aracMarkaListesi"
                                       :key="item.markaKodu"
                                       :label="item.markaAdi"
                                       :value="item.markaKodu"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item label='Model Adı'
                                  prop="modelAdi">:
                        <el-input
                                v-model="aracModelForm.modelAdi"
                                placeholder='Model Adı Giriniz'></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </div>
        <el-row class="col-p">
            <el-form-item>
                <el-button size="small" v-on:click="aracModelTanimla('aracModelForm')"
                           type="primary">
                    Tanımla
                </el-button>
            </el-form-item>
        </el-row>
    </el-form>

</template>

<script>
    import EventBus from '@/components/event-bus'
    import opsiyonService from '../../../../WSProvider/OpsiyonService'
    import notification from '../../../../notification'
    export default {
        name: "ModelEkle",
        mounted() {
            this.getAracMarkaListesi();
        },
        data() {
            return {
                aracMarkaListesi: [],
                aracModelListesi: [],
                aracModelForm: {
                    marka: '',
                    modelAdi: '',
                },
                rulesAracModel: {
                    marka: [{
                        required: true,
                        message: "Lütfen Marka Seçiniz",
                        trigger: 'blur'
                    }],
                    modelAdi: [{
                        required: true,
                        message: "Lütfen Model Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            markaChange(val) {
                this.aracModelForm.marka = val;
                this.getAracModelListesi();
            },
            getAracMarkaListesi() {
                opsiyonService.markaList(1, 0, 0).then((response) => {
                    if (response.status === 200) {
                        if(response.data.length > 0){
                            // console.log(this.$store.state.markaKodu)
                            this.aracModelForm.marka = this.$store.state.markaKodu;
                            this.getAracModelListesi();
                        }
                        this.aracMarkaListesi = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            getAracModelListesi() {
                opsiyonService.modelList(this.aracModelForm.marka,1, "","").then((response) => {
                    if (response.status === 200) {
                        this.aracModelListesi = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            aracModelTanimla(formName) {
                var dizi = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        opsiyonService.modelTanimlama(this.aracModelForm.marka,this.aracModelForm.modelAdi).then((response) => {
                            if (response.status === 200) {
                                this.aracModelListesi.push(response.data);
                                this.aracModelListesi.forEach(function (value) {
                                    dizi.push({
                                        secenekAdi: value.modelAdi,
                                        secenekKodu: value.modelKodu,
                                    })
                                });
                                EventBus.$emit("opsiyonList", true)
                                // this.$store.commit('changeOpsiyonList', dizi);
                                notification.Status('success', this, 'Model başarıyla eklendi.');
                                this.$refs[formName].resetFields();
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir model zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>